/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetContextInstanceSegmentsMembershipByEnvPathParams = NonNullable<
  operations['getContextInstanceSegmentsMembershipByEnv']['parameters']['path']
>;

export type GetContextInstanceSegmentsMembershipByEnvRequestBody = OperationRequestBodyContent<
  operations['getContextInstanceSegmentsMembershipByEnv']
>;

export interface Input extends GetContextInstanceSegmentsMembershipByEnvPathParams {
  apiVersion?: string;
  body: GetContextInstanceSegmentsMembershipByEnvRequestBody;
}

export async function getContextInstanceSegmentsMembershipByEnv(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/projects/{projectKey}/environments/{environmentKey}/segments/evaluate', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
